import RpcClass from "../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.services.ProductInSeasonService';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class ProductInSeasonService extends RpcClass{

    /**
     *  @class ProductInSeasonService
     *  @alias module:src/server/com/silkplm/rpc/plm/services/ProductInSeasonService.ProductInSeasonService
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param codeAuxiliaryUnitNumberId {string} 
     * @param productInSeasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     assignSKUNumberToProductInSeason(codeAuxiliaryUnitNumberId, productInSeasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/assign-s-k-u-number-to-product-in-season', [codeAuxiliaryUnitNumberId, productInSeasonId]);
    }
    /** 
     * @async
     * @param results {Object.<*, string>} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     bulkAssignOrderNumber(results) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/bulk-assign-order-number', [results]);
    }
    /** 
     * @async
     * @param results {Object.<*, string>} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     bulkAssignSkuNumber(results) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/bulk-assign-sku-number', [results]);
    }
    /** 
     * @async
     * @param productInSeasonIdString {string} 
     * @param colorIdString {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkIfLeatherColorVersionIsInOrder(productInSeasonIdString, colorIdString) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/check-if-leather-color-version-is-in-order', [productInSeasonIdString, colorIdString]);
    }
    /** 
     * @async
     * @param productInSeasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkIfProductInSeasonHasAnyColorVersionsDefined(productInSeasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/check-if-product-in-season-has-any-color-versions-defined', [productInSeasonId]);
    }
    /** 
     * @async
     * @param productInSeasonId {string} 
     * @param level {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkLevelCategorySymbols(productInSeasonId, level) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/check-level-category-symbols', [productInSeasonId, level]);
    }
    /** 
     * @async
     * @param numberOfProduct {number} 
     * @param categoryId {string} 
     * @param seasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     computeOrderNumberForNaokoWarning(numberOfProduct, categoryId, seasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/compute-order-number-for-naoko-warning', [numberOfProduct, categoryId, seasonId]);
    }
    /** 
     * @async
     * @param productInSeasonId {string} 
     * @param categoryId {string} 
     * @param seasonId {string} 
     * @param continuationVal {boolean} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     computeOrderNumberForProductInSeasonForNaokoPathAfterClickButton(productInSeasonId, categoryId, seasonId, continuationVal) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/compute-order-number-for-product-in-season-for-naoko-path-after-click-button', [productInSeasonId, categoryId, seasonId, continuationVal]);
    }
    /** 
     * @async
     * @param categoryId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/ValueAttribute.ValueAttribute[]>}
     */
     computeProductCategoryAttributesForProductInSeason(categoryId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/compute-product-category-attributes-for-product-in-season', [categoryId]);
    }
    /** 
     * @async
     * @param numberOfProduct {number} 
     * @param categoryId {string} 
     * @param formNumberId {string} 
     * @param seasonId {string} 
     * @param countryOfOrigin {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     computeSKUWarning(numberOfProduct, categoryId, formNumberId, seasonId, countryOfOrigin) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/compute-s-k-u-warning', [numberOfProduct, categoryId, formNumberId, seasonId, countryOfOrigin]);
    }
    /** 
     * @async
     * @param name {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     countSubSeasonsForSeason(name) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/count-sub-seasons-for-season', [name]);
    }
    /** 
     * @async
     * @param clazz {string} 
     * @param fieldName {string} 
     * @param fieldValue {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     findDictionaryEntityByFieldNameAndFieldValue(clazz, fieldName, fieldValue) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/find-dictionary-entity-by-field-name-and-field-value', [clazz, fieldName, fieldValue]);
    }
    /** 
     * @async
     * @param productId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/ProductInSeason.ProductInSeason[]>}
     */
     findProductInSeasonForProduct(productId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/find-product-in-season-for-product', [productId]);
    }
    /** 
     * @async
     * @param subSeasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number[]>}
     */
     findProductsInSeasonBySubSeasonId(subSeasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/find-products-in-season-by-sub-season-id', [subSeasonId]);
    }
    /** 
     * @async
     * @param id {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/dictionaries/RequiredTestStatus.RequiredTestStatus>}
     */
     findRequiredTestStatusById(id) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/find-required-test-status-by-id', [id]);
    }
    /** 
     * @async
     * @param seasonName {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/Season.Season>}
     */
     findSeasonByName(seasonName) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/find-season-by-name', [seasonName]);
    }
    /** 
     * @async
     * @param dates {module:src/server/com/silkplm/model/plm/DeliveryDateStore.DeliveryDateStore[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     formatDeliveryDateStores(dates) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/format-delivery-date-stores', [dates]);
    }
    /** 
     * @async
     * @param productInSeasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     generateOrderNumberForProductInSeasonFromButton(productInSeasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/product-in-season-service/generate-order-number-for-product-in-season-from-button', [productInSeasonId]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.services.ProductInSeasonService';
metadata.__type_short__ = 'ProductInSeasonService';
ProductInSeasonService.prototype.__metadata__ = metadata;

ProductInSeasonService.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/services/ProductInSeasonService */
export default ProductInSeasonService

export { ProductInSeasonService }
